// src/config/wecomConfig.js

// 根据环境获取企业微信配置
export const getWecomConfig = () => {
  const env = import.meta.env
  // Vite中环境变量需要以VITE_开头才能在客户端访问
  return {
    corpId: env.VITE_CORP_ID?.trim() || '',
    agentId: env.VITE_AGENT_ID?.trim() || ''
  }
}

// 导出企业微信常量
export const WecomEntryScene = {
  /** 从联系人详情进入 */
  CONTACT_PROFILE: 'contact_profile',
  /** 从单聊会话的工具栏进入 */
  SINGLE_CHAT_TOOLS: 'single_chat_tools',
  /** 从群聊会话的工具栏进入 */
  GROUP_CHAT_TOOLS: 'group_chat_tools',
  /** 从会话的聊天附件栏进入（企业微信 3.1.6+） */
  CHAT_ATTACHMENT: 'chat_attachment',
  /** 从微信客服的工具栏进入（企业微信 3.1.10+） */
  SINGLE_KF_TOOLS: 'single_kf_tools',
  /** 上下游单聊会话的工具栏（企业微信 4.0.8+） */
  CHAIN_SINGLE_CHAT_TOOLS: 'chain_single_chat_tools',
  /** 上下游群聊会话的工具栏（企业微信 4.0.8+） */
  CHAIN_GROUP_CHAT_TOOLS: 'chain_group_chat_tools',
  /** 从内部群群看板进入（企业微信 4.1.36+） */
  INTERNAL_GROUP_CHAT_BOARD: 'internal_group_chat_board',
  /** 除以上场景之外进入，例如工作台，聊天会话等 */
  NORMAL: 'normal',
}